import Home from "./Home/Home";

export const pages = {
    Home: Home
}